import { map } from 'lodash'

const state = {
  id: null,
  name: null,
  categories: [],
  showIsPrivate: true,
  updatedAt: '1970-01-01T00:00:00.000Z',
  externalIssuesUrl: null,
  hasAudits: false,
  allowUnplannedAudits: false,
  showUnscopedHistory: false,
  forwardIssues: {},
  isCheckpointsDefaultOk: null,
  suggestProvidersInSecurity: false
}

const getters = {
  attributes: (state) => {
    return {
      id: state.id,
      name: state.name,
      showIsPrivate: state.showIsPrivate,
      updatedAt: state.updatedAt,
      externalIssuesUrl: state.externalIssuesUrl,
      hasAudits: state.hasAudits,
      allowUnplannedAudits: state.allowUnplannedAudits,
      showUnscopedHistory: state.showUnscopedHistory,
      forwardIssues: state.forwardIssues,
      isCheckpointsDefaultOk: state.isCheckpointsDefaultOk,
      suggestProvidersInSecurity: !!state.suggestProvidersInSecurity
    }
  },
  categories: (state) => state.categories,
  findCategoryBySubcategoryId: (state) => (id) =>
    state.categories.find((category) =>
      category.childs.map((subcategory) => subcategory.id).includes(id)
    ),
  findCategoryById: (state) => (id) => {
    let cat = null
    state.categories.forEach((category) => {
      category.childs.forEach((subcategory) => {
        if (subcategory.id === id) {
          cat = subcategory
        }
      })
    })
    return cat
  }
}

const actions = {
  async load({ commit }, company) {
    const response = await this._vm.$SowellProxy.loadCompanyCategories(company)
    const filteredCategories = response.data.filter(
      (category) =>
        category.childs.length &&
        !category['is-cleaning-related']
    )

    const categories = map(filteredCategories, (category) => {
      const childs = map(category.childs, (subcategory) => {
        const child = {
          id: Math.trunc(subcategory.id),
          name: subcategory.name,
          img: subcategory.img,
          reasons: [],
          isHidden: subcategory['is-hidden']
        }
        if (subcategory['has-reasons']) {
          child.reasons = subcategory.reasons.map((reason) => {
            return {
              id: Math.trunc(reason.id),
              name: reason.name
            }
          })
        }
        return child
      })
      return {
        id: Math.trunc(category.id),
        name: category.name,
        img: category.img,
        allowTenantRequest: category['allow-tenant-request'],
        childs: childs.filter((child) => !child['is-hidden']),
        'base-category': category['base-category'],
        isHidden: category['is-hidden']
      }
    })

    let persistedCompany = {
      id: Math.trunc(company.id),
      name: company.name,
      updatedAt: company['updated-at'],
      showIsPrivate: company['show-is-private'],
      externalIssuesUrl: company['external-issues-url'],
      hasAudits: company['has-audits'],
      allowUnplannedAudits: company['allow-unplanned-audits'],
      showUnscopedHistory: company['show-unscoped-history'],
      forwardIssues: company['forward-issues'],
      isCheckpointsDefaultOk: company['is-checkpoints-default-ok'],
      suggestProvidersInSecurity: company['suggest-providers-in-security'],
      categories
    }
    commit('SET_ALL', persistedCompany)
    return response
  },
  reset({ commit }) {
    commit('RESET')
  }
}

const mutations = {
  SET_ALL(state, company) {
    state.id = company.id
    state.name = company.name
    state.categories = company.categories
    state.showIsPrivate = company.showIsPrivate
    state.hasAudits = company.hasAudits
    state.allowUnplannedAudits = company.allowUnplannedAudits
    state.showUnscopedHistory = company.showUnscopedHistory
    state.updatedAt = company.updatedAt
    state.externalIssuesUrl = company.externalIssuesUrl
    state.forwardIssues = company.forwardIssues
    state.isCheckpointsDefaultOk = company.isCheckpointsDefaultOk
    state.suggestProvidersInSecurity = company.suggestProvidersInSecurity
  },
  RESET(state) {
    state.id = null
    state.name = null
    state.categories = []
    state.showIsPrivate = true
    state.updatedAt = '1970-01-01T00:00:00.000Z'
    state.externalIssuesUrl = null
    state.hasAudits = false
    state.allowUnplannedAudits = false
    state.showUnscopedHistory = false
    state.forwardIssues = {}
    state.isCheckpointsDefaultOk = null
    state.suggestProvidersInSecurity = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
